import { useState } from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import AddOns from "../components/site/AddOns";
import AboutSection from "../components/site/AboutSection";
import ContactForm from "../components/site/ContactForm";
import Footer from "../components/site/Footer";

export default function Home() {
    const [selectedAddons, setSelectedAddons] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState("");

    const toggleAddon = (name) =>
        setSelectedAddons((prev) =>
            prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
        );

    const handleSelectPackage = (name) => {
        setSelectedPackage(name);
        document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div data-testid="home-page" className="min-h-screen bg-ac-bg text-white">
            <Navbar />
            <main>
                <Hero />
                <Services onSelectPackage={handleSelectPackage} />
                <AddOns selected={selectedAddons} onToggle={toggleAddon} />
                <AboutSection />
                <ContactForm
                    selectedAddons={selectedAddons}
                    selectedPackage={selectedPackage}
                    onPackageChange={setSelectedPackage}
                    onToggleAddon={toggleAddon}
                />
            </main>
            <Footer />
        </div>
    );
}
